import moment from 'moment'
export const formatDate = (date: string, formatString = 'MMMM YYYY'): string => {
  return moment(date).format(formatString)
}
